export default {"src":"/_next/static/media/circle-solid-orange.2e092a53.svg","height":512,"width":512};